// "Last active" signal — how long the user has been away from the app.
//
// Downread has no server-side last-login timestamp, so we keep one in localStorage
// under 'home-last-visit' (legacy key name, kept to preserve existing values; cleared
// on logout). It is written by App on every app start and whenever the app becomes
// visible again — NOT just on Home visits, so it reflects real app usage regardless of
// which page the user lands on. We capture the value ONCE when this module is first
// imported (app start, before recordActiveNow() overwrites it with "now"), so any page
// can ask how long the user was away this session even after we've refreshed the key.
//
// Missing/invalid => 0 => treated as "very long ago" by callers.

const HOME_LAST_VISIT_KEY = 'home-last-visit';

const lastActiveAtLoad: number =
  (typeof window !== 'undefined' && Number(window.localStorage.getItem(HOME_LAST_VISIT_KEY))) || 0;

/** Epoch ms of the user's previous activity (before this session), or 0 if none/invalid. */
export function getLastActiveMs(): number {
  return lastActiveAtLoad;
}

/** Stamp "now" as the user's latest activity. Call on app start and on resume; this does
 * NOT change what getLastActiveMs() returns this session (it stays the captured prior value). */
export function recordActiveNow(): void {
  try { window.localStorage.setItem(HOME_LAST_VISIT_KEY, String(Date.now())); } catch { /* ignore */ }
}
